export enum SpecialPaymentApprovalType {
  Unknown = 'Unknown',
  LineManager = 'LineManager',
  HRBusinessPartner = 'HRBusinessPartner',
  HeadOfHierarchy = 'HeadOfHierarchy',
  RegionalHrHead = 'RegionalHrHead',
  NMinus2 = 'NMinus2',
  GlobalHrBusinessPartner = 'GlobalHrBusinessPartner'
}
